export enum UserDriverEditRequestAddressType {
  STARTING = "STARTING",
  MAILING = "MAILING",
}

export enum UserDriverEditRequestFormOfEmployment {
  B2B = "B2B",
  EMPLOYMENT = "EMPLOYMENT",
}

export enum UserDriverEditRequestCitizenship {
  PL = "PL",
  DE = "DE",
  SK = "SK",
  CZ = "CZ",
  UA = "UA",
  RU = "RU",
  BY = "BY",
  LT = "LT",
}

export enum UserDriverEditRequestLanguage {
  PL = "PL",
  EN = "EN",
  DE = "DE",
  FR = "FR",
  ES = "ES",
  SK = "SK",
  CZ = "CZ",
  UA = "UA",
  RU = "RU",
  BY = "BY",
  LT = "LT",
}

export enum UserDriverEditRequestCarOwnership {
  OWNER = "OWNER",
  BUSINESS = "BUSINESS",
}

export type UserDriverEditRequestUser = {
  firstName: string;
  lastName: string;
  mobilePrimaryPrefix: string;
  mobilePrimary: string;
  mobileSecondaryPrefix: string | null;
  mobileSecondary: string | null;
  email: string;
};

export type UserDriverEditRequestDriver = {
  birthDate: string;
  birthPlace: string;
  idNumber: string;
  citizenship: UserDriverEditRequestCitizenship;
  languages: UserDriverEditRequestLanguage[];
  experience: number;
  carOwnership: UserDriverEditRequestCarOwnership;
  carMake: string;
  carModel: string;
  carRegNo: string;
  carProdYear: number;
  carSeatsNo: number;
};

export type UserDriverEditRequestAddress = {
  type: UserDriverEditRequestAddressType;
  lat: number;
  lon: number;
  country: string;
  town: string;
  zipCode: string;
  street: string;
  houseNo: string;
  apartment: string;
  description: string | null;
};

export type UserDriverEditRequestTaxiDriverAssociationForEmployment = {
  contractType: UserDriverEditRequestFormOfEmployment;
  fleetPartnerId: string | null;
  id: string;
};

export type UserDriverEditRequestTaxiDriverAssociationForB2B = {
  contractType: UserDriverEditRequestFormOfEmployment;
  taxId: string;
  regon: string | null;
  krsNo: string | null;
  fleetPartnerId: string | null;
  companyName: string;
  country: string;
  town: string;
  zipCode: string;
  street: string;
  houseNo: string;
  apartment: string;
  description: string;
  id: string;
};

export type UserDriverEditRequestTaxiDriverAssociation =
  | UserDriverEditRequestTaxiDriverAssociationForEmployment
  | UserDriverEditRequestTaxiDriverAssociationForB2B;

export type UserDriverEditRequestBody = {
  user: UserDriverEditRequestUser;
  driver: UserDriverEditRequestDriver;
  associations: UserDriverEditRequestTaxiDriverAssociation[];
  addresses: UserDriverEditRequestAddress[];
};

type UserDriverEditRequest = {
  user: UserDriverEditRequestUser;
  driver: UserDriverEditRequestDriver;
  associations: UserDriverEditRequestTaxiDriverAssociation[];
  addresses: UserDriverEditRequestAddress[];
};

export default UserDriverEditRequest;
